export const fr = {
    titre: "Accueil",
    titreOnglet: "AccèsD | Desjardins"
}
